import { Anchor, Group } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

export const BackLink = ({ to, label }: { to: string; label: string }) => (
  <Anchor component={Link} to={to} size="sm" c="dimmed" w="fit-content">
    <Group gap={4}>
      <IconArrowLeft size={14} />
      {label}
    </Group>
  </Anchor>
);
